import type { Position } from '../../services/api';
import type { ContractSelection } from './contractSelection';

type PositionWithQuoteMetadata = Position & {
  quote_status?: string;
  quote_received_at?: string;
};

/** Convert non-zero account positions into contract-picker suggestions. */
export const buildPositionSuggestions = (
  positions: PositionWithQuoteMetadata[],
  responseStale = false,
  responseTimestamp?: string,
): ContractSelection[] => {
  const suggestions = positions
    .filter((position) => position.symbol && Number(position.quantity || 0) !== 0)
    .map((position): ContractSelection => ({
      symbol: String(position.symbol).toUpperCase(),
      display_symbol: position.display_symbol,
      sec_type: position.secType || 'STK',
      con_id: position.con_id,
      exchange: position.exchange,
      currency: position.currency,
      local_symbol: position.local_symbol,
      trading_class: position.trading_class,
      last_trade_date_or_contract_month: position.last_trade_date_or_contract_month,
      multiplier: position.multiplier,
      current_price: position.current_price,
      current_price_stale: Boolean(position.quote_stale || responseStale),
      current_price_delayed: position.quote_status === 'DELAYED',
      current_price_received_at: position.quote_received_at || responseTimestamp,
    }));

  return Array.from(new Map(suggestions.map((suggestion) => [
    `${suggestion.symbol}-${suggestion.sec_type}-${suggestion.con_id || suggestion.local_symbol || ''}`,
    suggestion,
  ])).values());
};
